<template>
  <v-card>
    <v-card-title
      style="line-height: 1.4;margin: 0;color: #6a6a6a;font-size:24px;display: flex; flex-direction: row; align-items: start;">
      <v-select
        :items="filterRmbox"
        label="Rmbox"
        item-text="text"
        item-value="value"
        v-on:change="selectRmboxMenu"
        v-model="type"
        v-if="byType"
        solo
      ></v-select>
      <v-spacer></v-spacer>
      <v-select
        :items="filterState"
        label="Etats"
        v-on:change="selectStateMenu"
        v-model="state"
        v-if="byStatus"
        solo
      ></v-select>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Recherche"
        single-line
        v-if="byWord"
        hide-details
      ></v-text-field>
    </v-card-title>
    <template v-if="this.date_update_data && this.date_next_update_data">
      <div>
        <v-alert
                :value="true"
                color="error"
                icon="new_releases"
        >
          Dernière mise à jour : {{this.date_update_data}}
          <br/>
          Prochaine mise à jour dans : {{this.date_next_update_data}}
        </v-alert>
      </div>
    </template>
    <v-data-table
      :headers="CustomHeaders"
      :items="items"
      :loading="true"
      :no-data-text="no_data_text"
      :no-results-text="no_data_text"
      :rows-per-page-text="rows"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :disable-initial-sort="true"
      :rows-per-page-items="rows_per_page"
      :class="id"
      item-key="name"
    >

      <template slot="expand" slot-scope="props">
        <v-card flat v-for="(header,index) in headers.slice(-4,None)" :key="index">
          <v-card-text  v-if="header.value !=='data-table-expand'">{{header.text}} : {{props.item[header.value]}} </v-card-text>
        </v-card>
      </template>


      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom v-if="props.header.value === 'status'">
          <span slot="activator">
          {{ props.header.text }}
        </span>
          <span>
          <p>* OK =&gt; Succès de synchronisation</p><br>
          <p>* CRITICAL (code = 1) =&gt; Temps expiré</p><br>
          <p>* CRITICAL (code = 2) =&gt; Echec de synchronisation</p><br>
          <p>* SEEK - UNREACHABLE =&gt; Boîter débranché</p>
        </span>
        </v-tooltip>
        <span v-else slot="activator">
          {{ props.header.text }}
        </span>
      </template>
      <v-progress-linear :active="loading" slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props" >


        <td  v-if="!showExpend" v-for="(header,index) in CustomHeaders" :key="index" :class="props.item[header.id]"  >
          <div v-if="header.value === 'number_videos' && props.item.show_details_videos" class="number_videos">

            {{props.item[header.value]}}
            <v-icon
              large
              class="mr-2"
              @click="editItem(props.item.id)"
            >
              list
            </v-icon>

          </div>
          <div v-else-if="header.value === 'action'">
            <v-icon
                    class="mr-2"
                    title="Interventions"
                    @click="showBoxIntervention(props.item.id,props.item.name)"
            >
              build
            </v-icon>
          </div>
          <div v-else v-html="props.item[header.value]"></div>
        </td>


        <td v-if="showExpend" v-for="(header,index) in CustomHeaders" :key="index" :class="props.item[header.id]"  >
          <div v-if="header.value === 'number_videos' && props.item.show_details_videos" class="number_videos">

            {{props.item[header.value]}}
            <v-icon
              large
              class="mr-2"
              @click="editItem(props.item.id)"
            >
              list
            </v-icon>

          </div>
          <div v-else-if="header.value === 'action'">
            <v-icon
                    class="mr-2"
                    title="Interventions"
                    @click="showBoxIntervention(props.item.id,props.item.name)"
            >
              build
            </v-icon>
          </div>
          <div v-else v-html="props.item[header.value]"></div>

          <div class="expand-icon" v-if="header.value === 'data-table-expand' && showExpend"  @click="props.expanded = !props.expanded" >
            <v-icon
              large
              class="mr-2"
            >
              {{customIcon(props.expanded)}}
            </v-icon>
          </div>
        </td>



      </template>
      <template slot="pageText" slot-scope="props">
        Lignes {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
      </template>
      <template slot="no-data" v-if="!loading">
      </template>



    </v-data-table>
    <v-dialog v-model="dialog" class="video_missing" style="width: auto!important;">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Liste des vidéos manquantes</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="v-table__overflow">
          <v-container grid-list-md>
            <v-layout wrap>
              <missing-videos v-if="dialog" :id="id_missing" :type="type"></missing-videos>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="myModal" class="modal_intervention" style="width: auto!important;">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeIntervention">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Liste des interventions du boîtier « {{ rmbox_name }} »</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="v-table__overflow">
          <v-container grid-list-md>
            <v-layout wrap>
              <tab-intervention v-if="myModal" :headers="headers_intervention" :filterList="[{byType: false}, {byWord: true}, {byStatus: false}]" :sorting="sortingInt" api="api_dtable_list_dtable_intervention_rmboxs_list" :idRmbox="id_rmbox_intervention"></tab-intervention>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import {HTTP} from '../core/http/http-common';
  import Routing from '../core/router/router';
  import MissingVideos from "./missingVideos";
  import tabIntervention from "./tabContentIntervention";

  export default {
    components: {MissingVideos,tabIntervention},
    name: "tab-content",
    props: {
      headers: {
        type: Array,
        required: true
      },
      filterList: {
        type: Array,
        required: true
      },
      sorting: {
        type: Object,
        required: true
      },
      api: {
        type: String,
        required: true
      },
      defaultType: {
        type: String,
        default: ''
      },
        date_update_data: {
            type: String,
            default: ''
        },
        date_next_update_data: {
            type: String,
            default: ''
        },
    },
    computed: {

      CustomHeaders(){
        if(this.showExpend && this.headers.length > 5){
          let len =this.headers.length - 4
          let arr = this.headers.slice(0,len)
          arr.push({ text: '', value: 'data-table-expand' })
          return arr
        }else
          return this.headers
      },




    },
    data() {
      return {
        showExpend:false,
        maxWidth:1447,
        expanded: [],
        singleExpand: false,
          myModal: false,
          dialog: false,
        search: '',
        id_missing: '',
        draw: 0,
        rows: "Lignes par page",
        rows_per_page: [5, 10, 20, 25, {"text": "Tous", "value": -1}],
        filterRmbox: [{
          value: 'display',
          text: 'screenBox'
        }, {
          value: 'non-display',
          text: 'Rmbox'
        }],
        filterState: [
          {
            value: '',
            text: 'Tous les états'
          },
          {
            value: 'OK',
            text: 'OK'
          },
          {
            value: 'SAUF-OK',
            text: 'SAUF-OK'
          },
          {
            value: 'CRITICAL',
            text: 'CRITICAL'
          },
          {
            value: 'SEEK - UNREACHABLE',
            text: 'SEEK - UNREACHABLE'
          }],
        no_data_text: 'Pas de donnée',
        pagination: {
          rowsPerPage: 10
        },
        loading: true,
        items: [],
        totalItems: 0,
        type: '',
        state: '',
        byType: true,
        byWord: true,
        byStatus: true,
          headers_intervention: [
              {text : 'Remarque', value : 'remarque'},
              {text : 'Date reception', value : 'receptionDate'},
              {text : 'Date envoi', value : 'sendDate'},
              {text : 'Ancienne MAC', value : 'oldMac'},
              {text : 'Nouvelle MAC', value : 'newMac'},
              {text : 'Date 1ere mise en marche', value : 'firstStartedDate'}
          ],
          sortingInt : {
              remarque : 1,
              receptionDate : 2,
              sendDate : 3,
              oldMac : 4,
              newMac : 5,
              firstStartedDate : 6,
          },
          id_rmbox_intervention: null,
          rmbox_name: "",

      }
    },
    watch: {
      pagination: {
        handler(object) {
          this.query.type = this.type;
          this.query.status = this.state;
          this.query.length = object.rowsPerPage;
          this.query.start = object.rowsPerPage * (object.page - 1);
          this.query.columns = [];
          this.query.order = [];
          this.query.order[0] = {};
          if (object.sortBy !== null) {
            this.query.columns[this.sorting[object.sortBy]] = {};
            this.query.columns[this.sorting[object.sortBy]].orderable = true;
            this.query.order[0].column = this.sorting[object.sortBy];
          } else {
            this.query.columns[0] = {};
            this.query.columns[0].orderable = true;
            this.query.order[0].column = 0;
          }
          if (object.descending) {
            this.query.order[0].dir = "desc"
          } else {
            this.query.order[0].dir = "asc"
          }
          this.getData();
        },
        deep: true
      },
      search: {
        handler(object) {
          if (object === '') {
            this.query.search = {};
          } else {
            this.query.search.value = object;
          }
          this.getData();
        }
      }
    },
    methods: {
      customIcon(expanded){
        if(!expanded )
          return "expand_more"
        else
          return "expand_less"
      },
      editItem(id) {
        this.id_missing = id;
        this.dialog = true
      },
      selectRmboxMenu(value) {
        this.query.type = value;
        if (!this.loading) {
          this.getData()
        }
      },
      selectStateMenu(value) {
        this.query.status = value;
        if (!this.loading) {
          this.getData()
        }
      },
        showBoxIntervention(id, name){
            this.id_rmbox_intervention=id;
            this.myModal=true;
            this.rmbox_name=name;
        },
      getData() {
        let self = this;
        self.loading = true;
        this.query.draw++;
        HTTP.get(Routing.generate(this.api, this.query))
          .then(function (response) {

            if (response.data.code === 200) {
              self.$nextTick(function () {
                self.loading = false;
                self.items = response.data.data;
                self.totalItems = response.data.recordsFiltered;
              })
            }
            else {
              self.loading = false;
            }
          }, function (error) {
            console.log(error)
            self.loading = false;

          })
      },
      close() {
        this.dialog = false
      },
        closeIntervention() {
            this.myModal = false
        },

      updateDimensions () {
        if(window.innerWidth > this.maxWidth) {
          this.showExpend = false
          this.expanded=false
        }else{
          this.showExpend = true
        }
      }
    },
    created() {
      this.query = {
        length: 10,
        start: 0,
        draw: 0
      };
      this.query.type = '';
      this.query.status = '';
      this.query.columns = [];
      this.query.columns[0] = {};
      this.query.columns[0].orderable = true;
      this.query.order = [];
      this.query.order[0] = {};
      this.query.order[0].column = 0;
      this.query.order[0].dir = 'asc';
      this.query.search = {};
      this.updateDimensions()
    },
    mounted() {
      this.type = this.defaultType;
      this.query.type = this.type;
      const menu = document.querySelectorAll('.v-menu__content');
      menu.forEach(function (item) {
        document.getElementById('wrapper').insertBefore(item, document.getElementById('wrapper').childNodes[0]);
      })
      const tooltip = document.querySelectorAll('.v-tooltip__content');
      tooltip.forEach(function (item) {
        document.getElementById('wrapper').insertBefore(item, document.getElementById('wrapper').childNodes[0]);
      })
      var self = this;
      this.filterList.forEach(function (item) {
        var keys = Object.keys(item);
        self[keys[0]] = item[keys[0]];
      })

      window.addEventListener('resize',function () {
        self.updateDimensions();
      })
    }
  }
</script>

<style lang="scss">

  #status td {
    text-align: center;
  }

  .OK div, .CRITICAL div, .SEEK-UNREACHABLE div {
    color: #fff;
    width: 165px;
    margin: 0 auto;
    padding: 10px;
    text-align: center;
  }

  .OK div {
    background: #5eba7d;
  }

  .CRITICAL div {
    background: #e64320;
  }

  .SEEK-UNREACHABLE div {
    background: #000000;
  }

  .number_videos {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .v-dialog {
      width: auto !important;
    }

  .expand-icon{
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/tabContent.vue